import {AbstractControl, AsyncValidatorFn} from "@angular/forms";
import {first, timer} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {ProductService} from "../services/api";

// Validator to check if a short name already exists
export function shortNameValidator(productService: ProductService): AsyncValidatorFn {
    return (control: AbstractControl) => {
        // Delay the validation by 700 milliseconds
        return timer(700).pipe(switchMap(() => {
            return productService.getUsedShortNames().pipe()
                .pipe(
                    // Check if the control value exists in the list of short names
                    map((shortNames) =>
                        (shortNames.find(shortName => shortName == control.value) !== undefined) ? {shortNameAlreadyExists: true} : null
                    )
                ).pipe(
                    // Complete the observable after the first emission
                    first()
                );
        }))
    };
}
